import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { GroupOfManagersItem } from '@modules/groups-of-managers/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  GROUPS_OF_MANAGERS_LIST_API_URL,
  GROUPS_OF_MANAGERS_LIST_QUERY_KEY,
  GROUPS_OF_MANAGERS_PERMISSIONS,
} from '@modules/groups-of-managers/constants';

export default function useGroupsOfManagersListQuery(): IContextQueryResult<GroupOfManagersItem[], Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<GroupOfManagersItem[], Error>({
    queryKey: [GROUPS_OF_MANAGERS_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<GroupOfManagersItem[]>(GROUPS_OF_MANAGERS_LIST_API_URL, {
      signal,
      permission: GROUPS_OF_MANAGERS_PERMISSIONS.SHOW,
    }),
  });
}
